<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="manageProductGroupAddEditForm">
      <div class="field-validation-error"></div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input formControlName="label" type="text" maxlength="50" placeholder="Label" />
              <label>Label</label>
              <div
                *ngIf="
                  (submitted || manageProductGroupAddEditForm.controls['label'].touched) &&
                  manageProductGroupAddEditForm.controls['label'].errors
                "
              >
                <div
                  *ngIf="manageProductGroupAddEditForm.controls['label'].errors?.['required']"
                  class="input-error"
                >
                  Label is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row checkbox-text-margin">
        <div class="col-sm-2 mt-2" class="checkbox-text checkBoxAlienMent">
          <input
            type="checkbox"
            class="chkOverview"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="isPublicValue"
            (change)="isPublic($event)"
          />
          <span>Public</span>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
